const dashboardTypes = {
    GET_DASHBOARD_REVENUE_ACTION: "GET_DASHBOARD_REVENUE_ACTION",
    GET_DASHBOARD_REVENUE_SUCCESS: "GET_DASHBOARD_REVENUE_SUCCESS",
    GET_DASHBOARD_REVENUE_FAILED: "GET_DASHBOARD_REVENUE_FAILED",
    GET_DASHBOARD_MONTH_REVENUE_ACTION: "GET_DASHBOARD_MONTH_REVENUE_ACTION",
    GET_DASHBOARD_MONTH_REVENUE_SUCCESS: "GET_DASHBOARD_MONTH_REVENUE_SUCCESS",
    GET_DASHBOARD_MONTH_REVENUE_FAILED: "GET_DASHBOARD_MONTH_REVENUE_FAILED",
}

export default dashboardTypes;